export const environment = {
    production: false,
    VERSION: '1.0.16-dev',
    API_URL: 'wss://api-tts-v02.zevo-tech.com:2083', // Pus temporar URL de producție (nu avem încă un URL dev)
    BACKEND_URL: 'https://tts-backend.zevo-tech.com', // Pus temporar URL de producție
    API_KEY: 'ttsdemo',
};
